import { noOfDaysBetweenTwoDates } from "../../../../utils/fn";
import { objectToQueryString, updateStatus } from "../../../site/fn";


const common_api = process.env.REACT_APP_NODE_SERVICE_BASE_URL;
const asset_api = process.env.REACT_APP_ASSET_SERVICE_BASE_URL;
const token = localStorage.getItem("zTaskAuthToken");

// Helper function for date formatting
export const formatDateToDDMMYYYY = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// ========================================
// 🔥 COMPLETE FIX: fetchWorkOrdersWithDetails function
// ========================================

// ========================================
// 🔥 OPTIMIZED: Add Caching to Work Order Fetch
// Add this BEFORE the fetchWorkOrdersWithDetails function (around line 15)
// ========================================

// Cache for work orders (valid for 5 minutes)
let workOrdersCache = null;
let workOrdersCacheTime = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

// ========================================
// 🔥 UPDATED: fetchWorkOrdersWithDetails with caching
// REPLACE the entire function starting around line 17
// ========================================

export const fetchWorkOrdersWithDetails = async (forceRefresh = false) => {
  console.log('🚀 [fetchWorkOrdersWithDetails] Starting fetch...');
  
  // ✅ Check cache first (unless force refresh)
  if (!forceRefresh && workOrdersCache && workOrdersCacheTime) {
    const now = Date.now();
    const cacheAge = now - workOrdersCacheTime;
    
    if (cacheAge < CACHE_DURATION) {
      console.log('✅ [fetchWorkOrdersWithDetails] Using cached data (age:', Math.round(cacheAge / 1000), 'seconds)');
      return workOrdersCache;
    } else {
      console.log('⚠️ [fetchWorkOrdersWithDetails] Cache expired, fetching fresh data');
    }
  }
  
  try {
    const token = localStorage.getItem("zTaskAuthToken");
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    console.log('📡 [fetchWorkOrdersWithDetails] Fetching work orders, customers, and projects...');

    // Fetch all three data sources in parallel
    const [workOrdersRes, customersRes, projectsRes] = await Promise.all([
      fetch(`${common_api}/work-order/api/work-orders`, { headers }),
      fetch(`${common_api}/customer/api/customers`, { headers }),
      fetch(`${process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL}/api/get-project`, { headers })
    ]);

    console.log('📡 [fetchWorkOrdersWithDetails] Response statuses:', {
      workOrders: workOrdersRes.ok ? workOrdersRes.status : 'FAILED',
      customers: customersRes.ok ? customersRes.status : 'FAILED',
      projects: projectsRes.ok ? projectsRes.status : 'FAILED'
    });

    if (!workOrdersRes.ok) {
      console.error('❌ Work orders fetch failed:', workOrdersRes.status);
      return [];
    }
    if (!customersRes.ok) {
      console.error('❌ Customers fetch failed:', customersRes.status);
    }
    if (!projectsRes.ok) {
      console.error('❌ Projects fetch failed:', projectsRes.status);
    }

    const workOrders = await workOrdersRes.json();
    const customers = customersRes.ok ? await customersRes.json() : [];
    const projectsData = projectsRes.ok ? await projectsRes.json() : { projects: [] };

    console.log('📊 [fetchWorkOrdersWithDetails] Raw data received:', {
      workOrders: workOrders.length,
      customers: customers.length,
      projects: projectsData.projects?.length || 0
    });

    // Create customer lookup map
    const customerMap = {};
    customers.forEach(c => {
      customerMap[c.id] = c.name;
      customerMap[String(c.id)] = c.name;
    });

    // Create project lookup map
    const projectMap = {};
    (projectsData.projects || []).forEach(p => {
      projectMap[p.projectId] = p.projectName;
      projectMap[String(p.projectId)] = p.projectName;
    });

    // Format work orders with proper customer and project names
    const formattedWorkOrders = workOrders.map(wo => {
      let customerName = customerMap[wo.cust_id] || customerMap[String(wo.cust_id)];
      if (!customerName) {
        console.warn(`⚠️ Customer not found for cust_id: ${wo.cust_id}`);
        customerName = 'Unknown Customer';
      }
      
      let projectName = projectMap[wo.project_id] || projectMap[String(wo.project_id)];
      if (!projectName) {
        console.warn(`⚠️ Project not found for project_id: ${wo.project_id}`);
        projectName = 'Unknown Project';
      }
      
      return {
        id: wo.id,
        value: wo.wo_no,
        label: wo.wo_no,
        wo_no: wo.wo_no,
        wo_date: wo.wo_date,
        customer_name: customerName,
        project_name: projectName,
        cust_id: wo.cust_id,
        project_id: wo.project_id,
        amendment_no: wo.amendment_no,
        amendment_date: wo.amendment_date,
        original: wo
      };
    });

    console.log('✅ [fetchWorkOrdersWithDetails] Successfully formatted', formattedWorkOrders.length, 'work orders');
    
    // ✅ Update cache
    workOrdersCache = formattedWorkOrders;
    workOrdersCacheTime = Date.now();
    console.log('💾 [fetchWorkOrdersWithDetails] Cache updated');
    
    return formattedWorkOrders;
  } catch (error) {
    console.error("❌ [fetchWorkOrdersWithDetails] Error:", error);
    console.error("❌ [fetchWorkOrdersWithDetails] Stack:", error.stack);
    return [];
  }
};

// ✅ Export function to clear cache when needed
export const clearWorkOrdersCache = () => {
  workOrdersCache = null;
  workOrdersCacheTime = null;
  console.log('🗑️ Work orders cache cleared');
};

// --- Master Form Configuration (invoice_master) ---
export const masterFormHeading = "Invoice";
export const uriBasePath = "invoices";
export const newRecord = `/invoices/new`;
export const masterSubmitApi = `${common_api}/invoice/api/invoices`;
export const masterListApi = `${common_api}/invoice/api/invoices`;
export const listApi = masterListApi;
export const submitMasterFirst = false;

// Table fields for Invoice module

export const statusField = "current_status";
export const disabledOnStatusValues = [
  ["Drafted", "not eq"],
  ["Rejected", "not in"],
];
export const statuses = Object.freeze([
  {
    id: "drafts",
    name: "Your Drafts",
    href: "drafts",
    value: "Drafted",
    permissionName: "set",
    buttonLabel: "Save as Draft",
    enabledOnStatus: ["Drafted", "Rejected by Checker", "Rejected by Approver", null, undefined],
    submit: async (id, handleMasterSubmit, approvers, navigate) => {
      await handleMasterSubmit();
      if (navigate) {
        setTimeout(() => {
          navigate('/invoices');
        }, 1500);
      }
    },
  },
  {
    id: "waiting-for-check",
    href: "check",
    fields: ["inv_check_status"],
    value: ["Waiting for check"],
    permissionName: "set",
    buttonLabel: "Send for Checking",
    enabledOnStatus: ["Drafted", "Rejected by Checker"],
    submit: async (id, subFn, checkers, navigate) => {
      await updateStatus(
        masterListApi,
        id,
        "Check Invoice",
        "waiting",
        null,
        "Invoice sent for checking",
        checkers
      );
      if (navigate) {
        setTimeout(() => {
          navigate('/invoices');
        }, 1500);
      }
    },
  },
  {
    id: "check-invoice",
    href: "checking",
    fields: ["inv_check_status"],
    value: ["Waiting for check"],
    permissionName: "CHECK",
    buttonLabel: "Check Actions",
    enabledOnStatus: ["Waiting for check"],
    approveForApproval: async (id, approvers, navigate) => {
      await updateStatus(
        masterListApi,
        id,
        "Check Invoice",
        "approved",
        null,
        "Invoice approved by checker and sent for approval",
        approvers
      );
      if (navigate) {
        setTimeout(() => {
          navigate('/invoices');
        }, 1500);
      }
    },
    reject: async (id, remark, navigate) => {
      await updateStatus(
        masterListApi,
        id,
        "Check Invoice",
        "rejected",
        remark,
        "Invoice rejected by checker"
      );
      if (navigate) {
        setTimeout(() => {
          navigate('/invoices');
        }, 1500);
      }
    },
  },
  {
    id: "waiting-for-approval",
    href: "approval",
    fields: ["inv_approval_status"],
    value: ["Waiting for approval"],
    permissionName: "APPROVE",
    buttonLabel: "Approval Actions",
    enabledOnStatus: ["Waiting for approval"],
    approve: async (id, navigate) => {
      await updateStatus(
        masterListApi,
        id,
        "Approval",
        "approved",
        null,
        "Invoice approved successfully"
      );
      if (navigate) {
        setTimeout(() => {
          navigate('/invoices');
        }, 1500);
      }
    },
    reject: async (id, remark, navigate) => {
      await updateStatus(
        masterListApi,
        id,
        "Approval",
        "rejected",
        remark,
        "Invoice rejected by approver"
      );
      if (navigate) {
        setTimeout(() => {
          navigate('/invoices');
        }, 1500);
      }
    },
  },
  // {
  //   id: "print",
  //   name: "Print",
  //   href: "print",
  //   fields: ["inv_print"],
  //   value: [true],
  //   permissionName: "PRINT",
  //   buttonLabel: "Print",
  //   enabledOnStatus: "Approved",
  //   submit: (id) => {
  //     window.location.href = `/invoices/${id}`;
  //   },
  // },
]);

export const tableFields = [
  { fieldName: "id", displayName: "ID" },
  { fieldName: "doc_no", displayName: "Invoice No." },
  { fieldName: "inv_date", displayName: "Invoice Date" },
  { fieldName: "wo_id", displayName: "Work Order No." },
  { fieldName: "current_status", displayName: "Current Status" },
  { fieldName: "start_date", displayName: "Invoice From date" },
  { fieldName: "end_date", displayName: "Invoice To date" },
  { fieldName: "amount", displayName: "Total Amount" },
  {
    fieldName: "active",
    displayName: "Active",
    render: (value) => (value ? "Yes" : "No"),
  },
];

export const memoizedFn = (fn) => {
  const cache = new Map();
  return async (...args) => {
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = await fn(...args);
    cache.set(key, result);
    return result;
  };
};

export const getCustomerStateNo = memoizedFn(async (masterFormData) => {
  const wo_id = masterFormData.wo_id;
  if (!wo_id) return false;
  const obj = {
    selectedFields: ["state_master.state_no"],
    joins: [
      {
        type: "INNER JOIN",
        fromTable: "work_order_master",
        fromColumn: "cust_id",
        toTable: "customers",
        toColumn: "id",
      },
      {
        type: "INNER JOIN",
        fromTable: "customers",
        fromColumn: "state_id",
        toTable: "state_master",
        toColumn: "id",
      },
    ],
    conditions: [
      {
        type: "id_match",
        table: "work_order_master",
        column: "id",
        value: wo_id,
      },
    ],
  };
  const queryString = objectToQueryString(obj);
  const res = await fetch(
    `${common_api}/work-order/api/work-orders?${queryString}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  if (!res.ok) {
    return false;
  }
  const data = await res.json();
  return data[0].state_no;
});

let COMPANY_STATE = null;
export const getCompanyState = async () => {
  if (COMPANY_STATE) return;
  try {
    const res = await fetch(
      `${common_api}/api/get-column/company_model/state_id`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (!res.ok) {
      throw new Error("Failed to fetch company state.");
    }
    const data = await res.json();
    if (data && data.length > 0 && data[0].value) {
      COMPANY_STATE = parseInt(data[0].value);
    } else {
      console.warn(
        "Company GST number not found or empty. Defaulting COMPANY_STATE to null."
      );
      COMPANY_STATE = null;
    }
  } catch (error) {
    console.error("Error fetching company state:", error);
    COMPANY_STATE = null;
  }
};

export const masterFormFields = [
  {
    fieldName: "doc_no",
    displayName: "Invoice No.",
    sequence: 0,
    readOnly: true,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "inv_date",
    displayName: "Invoice Date",
    sequence: 0,
    required: true,
    tag: "input",
    inputType: "date",
    defaultValue: "now",
    readOnly: true,
    formatDisplay: formatDateToDDMMYYYY,
  },
  {
    fieldName: "start_date",
    displayName: "Invoice From date",
    sequence: 1,
    required: true,
    tag: "input",
    inputType: "date",
    defaultValue: "now",
    formatDisplay: formatDateToDDMMYYYY,
  },
  {
    fieldName: "end_date",
    displayName: "Invoice To date",
    sequence: 1,
    required: true,
    tag: "input",
    inputType: "date",
    defaultValue: {
      time: [23, 59],
    },
    formatDisplay: formatDateToDDMMYYYY,
  },
  // ========================================
  // 🔥 FIXED #2: Work Order Field (strict containment filter)
  // ========================================
  {
  fieldName: "wo_id",
  displayName: "Work Order No.",
  sequence: 2,
  tag: "combobox",
  required: true,
  data: {
    dependsOnField: ["start_date", "end_date"],
  },
  getOptions: async (formData) => {
    console.log('🚀 [WO Options] === START OF FILTERING ===');
    console.log('🚀 [WO Options] Input dates:', {
      start_date: formData?.start_date,
      end_date: formData?.end_date,
      start_date_type: typeof formData?.start_date,
      end_date_type: typeof formData?.end_date
    });
    
    // Fetch work orders with customer and project names
    let allOptions = await fetchWorkOrdersWithDetails();
    console.log('📊 [WO Options] Total WOs fetched:', allOptions.length);
    
    // ✅ FIXED: Filter by date range BEFORE setting count (strict containment)
    if (formData?.start_date && formData?.end_date) {
      // Helper function to get date-only string (YYYY-MM-DD) - improved for invalid dates
      const getDateOnly = (dateInput) => {
        if (!dateInput) {
          console.log('⚠️ [getDateOnly] Received null/undefined input');
          return null;
        }
        const date = new Date(dateInput);
        if (isNaN(date.getTime())) {  // ✅ FIXED: Handle invalid dates
          console.log(`❌ [getDateOnly] Invalid date: ${dateInput}`);
          return null;
        }
        const dateStr = date.toISOString().split('T')[0];
        console.log(`📅 [getDateOnly] Input: ${dateInput} → Output: ${dateStr}`);
        return dateStr;
      };
      
      const invoiceStartStr = getDateOnly(formData.start_date);
      const invoiceEndStr = getDateOnly(formData.end_date);
      
      if (!invoiceStartStr || !invoiceEndStr) {  // ✅ FIXED: Early exit if invalid
        console.log('❌ [WO Options] Invalid invoice dates - no filtering');
        return [];
      }
      
      console.log('🔍 [WO Options] Invoice date range (strings):', {
        start: invoiceStartStr,
        end: invoiceEndStr
      });
      
      // Filter work orders where WO overlaps invoice period
      const filteredOptions = allOptions.filter((wo, index) => {
        console.log(`\n--- Checking WO ${index + 1}/${allOptions.length}: ${wo.wo_no} ---`);
        
        if (!wo.original?.wo_start || !wo.original?.wo_end) {
          console.log('❌ Missing dates:', {
            wo_start: wo.original?.wo_start,
            wo_end: wo.original?.wo_end
          });
          return false;
        }
        
        // Get date-only strings for comparison
        const woStartStr = getDateOnly(wo.original.wo_start);
        const woEndStr = getDateOnly(wo.original.wo_end);
        
        if (!woStartStr || !woEndStr) {  // Exclude invalid WO dates
          console.log('❌ Invalid WO dates:', { woStartStr, woEndStr });
          return false;
        }
        
        console.log('📋 WO dates:', {
          wo_no: wo.wo_no,
          woStartStr,
          woEndStr
        });
        
        // 🔥 UPDATED: OVERLAP CHECK (WO overlaps invoice)
        // - WO starts on or before invoice end AND
        // - WO ends on or after invoice start
        const woStartsBeforeInvoiceEnd = woStartStr <= invoiceEndStr;
        const woEndsAfterInvoiceStart = woEndStr >= invoiceStartStr;
        const hasOverlap = woStartsBeforeInvoiceEnd && woEndsAfterInvoiceStart;
        
        console.log('🔍 Overlap check:', {
          woStartsBeforeInvoiceEnd: `${woStartStr} <= ${invoiceEndStr} = ${woStartsBeforeInvoiceEnd}`,
          woEndsAfterInvoiceStart: `${woEndStr} >= ${invoiceStartStr} = ${woEndsAfterInvoiceStart}`,
          hasOverlap
        });
        
        if (hasOverlap) {
          console.log('✅ INCLUDED (overlaps):', wo.wo_no);
        } else {
          console.log('❌ EXCLUDED (no overlap):', wo.wo_no);
        }
        
        return hasOverlap;
      });
      
      console.log('📊 [WO Options] Filtering complete:', {
        total: allOptions.length,
        filtered: filteredOptions.length,
        excluded: allOptions.length - filteredOptions.length
      });
      
      // ✅ Set count AFTER filtering
      if (formData) {
        formData._workOrderCount = filteredOptions.length;
        console.log('✅ [WO Options] Set count to:', filteredOptions.length);
      }
      
      console.log('🎉 [WO Options] === END OF FILTERING ===\n');
      return filteredOptions;
    } else {
      console.log('⚠️ [WO Options] No date filtering - start_date or end_date missing');
      // ✅ Set count for unfiltered results
      if (formData) {
        formData._workOrderCount = allOptions.length;
      }
      return allOptions;
    }
  },
  getOptionLabel: (option) => {
    if (!option || typeof option !== 'object') return String(option || '');
    
    const wo_no = option.wo_no || option.label || 'N/A';
    const customer_name = option.customer_name || 'Unknown Customer';
    const project_name = option.project_name || 'Unknown Project';
    
    return `${wo_no} | ${customer_name} | ${project_name}`;
  },
  getOptionValue: (option) => option?.id || option?.value,
  renderOption: (option) => {
    if (!option) return null;
    
    const wo_no = option.wo_no || 'N/A';
    const customer_name = option.customer_name || 'Unknown Customer';
    const project_name = option.project_name || 'Unknown Project';
    
    return (
      <div style={{ padding: '12px 14px', borderBottom: '1px solid #f0f0f0' }}>
        <span style={{ fontWeight: 600, marginRight: '8px' }}>{wo_no}</span>
        <span style={{ marginRight: '4px', color: '#6c757d' }}>|</span>
        <span style={{ marginRight: '8px', color: '#6c757d' }}>{customer_name}</span>
        <span style={{ marginRight: '4px', color: '#6c757d' }}>|</span>
        <span style={{ color: '#6c757d' }}>{project_name}</span>
      </div>
    );
  }
},
  {
    fieldName: "wo_date",
    displayName: "Work Order Date",
    sequence: 3, // Moved to next line (sequence 3)
    readOnly: true,
    tag: "input",
    inputType: "date",
    formatDisplay: formatDateToDDMMYYYY,
  },

  {
    fieldName: "assets",
    displayName: "Assets",
    sequence: 4,
    tag: "list",
    data: {
      dependsOnField: "wo_id",
    },
    identifier: "asset_id",
    getRows: async (formData) => {
  const woId = formData.wo_id?.id || formData.wo_id;
  if (!woId) return [];
  const start_date = formData.start_date;
  const end_date = formData.end_date;

  try {
    const obj_tran = {
      selectedFields: [
        "DISTINCT work_order_tran.id",
        "work_order_tran.*",
        "assets.name",
        "assets.serial_number",
        "assets.registration_number",
        "assets.asset_type",
      ],
      joins: [
        {
          type: "INNER JOIN",
          fromTable: "work_order_tran",
          fromColumn: "asset_id",
          toTable: "assets",
          toColumn: "id",
        },
      ],
      orConditions: [
        {
          type: "date_range_column",
          table: "work_order_tran",
          date: start_date,
          startColumn: "start_date",
          endColumn: "end_date",
        },
        {
          type: "date_range_column",
          table: "work_order_tran",
          date: end_date,
          startColumn: "start_date",
          endColumn: "end_date",
        },
        {
          type: "date_range",
          table: "work_order_tran",
          column: "start_date",
          start: start_date,
          end: end_date,
        },
        {
          type: "date_range",
          table: "work_order_tran",
          column: "end_date",
          start: start_date,
          end: end_date,
        },
      ],
    };
    const queryStringTran = objectToQueryString(obj_tran);
    const res = await fetch(
      `${common_api}/work-order/api/work-order-tran/${woId}?${queryStringTran}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (!res.ok) {
      throw new Error("Failed to fetch work order transactions.");
    }
    const transactions_from_api = await res.json();
    
    console.log('📦 [getRows] Fetched WO transactions:', transactions_from_api.length);
    
    // 🔥 NEW: Enrich with asset data if missing
    const enrichedTransactions = await Promise.all(
      transactions_from_api.map(async (tran) => {
        // Check if asset data is missing
        if (!tran.name || !tran.asset_type) {
          console.log(`📦 [getRows] Asset data missing for asset_id: ${tran.asset_id}, fetching...`);
          try {
            const assetRes = await fetch(
              `${asset_api}/api/assets/${tran.asset_id}`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            
            if (assetRes.ok) {
              const assetData = await assetRes.json();
              console.log(`✅ [getRows] Fetched asset data for ${tran.asset_id}:`, assetData.name);
              
              // Add missing asset fields
              tran.name = assetData.name;
              tran.asset_type = assetData.asset_type;
              tran.serial_number = assetData.serial_number || tran.serial_number;
              tran.registration_number = assetData.registration_number || tran.registration_number;
            } else {
              console.warn(`⚠️ [getRows] Failed to fetch asset ${tran.asset_id}`);
            }
          } catch (error) {
            console.error(`❌ [getRows] Error fetching asset ${tran.asset_id}:`, error);
          }
        } else {
          console.log(`✅ [getRows] Asset data already present for ${tran.asset_id}:`, tran.name);
        }
        return tran;
      })
    );
    
    console.log('🎉 [getRows] Returning enriched transactions:', enrichedTransactions.length);
    return enrichedTransactions;
  } catch (error) {
    console.error("Error fetching assets list:", error);
    return [];
  }
},

    uniqueFields: ["invoice_for"],
    columns: [
      {
        fieldName: "name",
        headName: "Asset Name",
      },
      { 
        fieldName: "asset_type", 
        headName: "Asset Type" 
      },
      { 
        fieldName: "start_date", 
        headName: "Start date",
        format: (value) => formatDateToDDMMYYYY(value),
      },
      { 
        fieldName: "end_date", 
        headName: "End date",
        format: (value) => formatDateToDDMMYYYY(value),
      },
      { fieldName: "daily_rate", headName: "Daily Rate" },
      { fieldName: "monthly_rate", headName: "Monthly Rate" },
      { fieldName: "mob", headName: "Mob" },
      { fieldName: "demob", headName: "Demob" },
    ],
  },
  {
    fieldName: "amendment_no",
    displayName: "Amendment No.",
    sequence: 5,
    readOnly: true,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "amendment_date",
    displayName: "Amendment Date",
    sequence: 5,
    readOnly: true,
    tag: "input",
    inputType: "date",
    formatDisplay: formatDateToDDMMYYYY,
  },
  {
    fieldName: "cr_period",
    displayName: "Credit Period (Days)",
    sequence: 6,
    tag: "input",
    inputType: "number",
    defaultValue: 0,
  },
  {
    fieldName: "due_date",
    displayName: "Due Date",
    sequence: 6,
    readOnly: true,
    tag: "input",
    inputType: "date",
    formatDisplay: formatDateToDDMMYYYY,
  },
  {
    fieldName: "inv_rem",
    displayName: "Invoice Remarks",
    sequence: 8,
    tag: "textarea",
  },
  {
    fieldName: "taxable_amt",
    tag: "hidden",
    defaultValue: (masterData, transactionData) => {
      return transactionData.reduce((a, t) => a + t.taxable_amount, 0);
    },
  },
  {
    fieldName: "tot_sgst",
    tag: "hidden",
    defaultValue: (masterData, transactionData) => {
      return transactionData.reduce((a, t) => a + t.sgst_amount, 0);
    },
  },
  {
    fieldName: "tot_cgst",
    tag: "hidden",
    defaultValue: (masterData, transactionData) => {
      return transactionData.reduce((a, t) => a + t.cgst_amount, 0);
    },
  },
  {
    fieldName: "tot_igst",
    tag: "hidden",
    defaultValue: (masterData, transactionData) => {
      return transactionData.reduce((a, t) => a + t.igst_amount, 0);
    },
  },
  {
    fieldName: "amount",
    tag: "hidden",
    defaultValue: (masterData, transactionData) => {
      return transactionData.reduce((a, t) => a + t.amount, 0);
    },
  },
];

export const masterValidationRules = [
  {
    fields: ["inv_date", "wo_id", "start_date", "end_date"],
    validator: (formData, currentErrors) => {
      const errors = { ...currentErrors };
      const requiredFields = ["inv_date", "wo_id", "start_date", "end_date"];
      requiredFields.forEach((field) => {
        if (!formData[field] && formData[field] !== false) {
          errors[field] = `${
            masterFormFields.find((f) => f.fieldName === field)?.displayName ||
            field
          } is required.`;
        }
      });

      const periodStartObj = formData.start_date
        ? new Date(formData.start_date)
        : null;
      const periodEndObj = formData.end_date
        ? new Date(formData.end_date)
        : null;

      // ✅ ONLY CHECK: start date vs end date
      if (
        periodStartObj &&
        periodEndObj &&
        periodEndObj.getTime() < periodStartObj.getTime()
      ) {
        errors.end_date = "Invoice Period End Date cannot be before Invoice Period Start Date.";
      }

      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        return errors;
      }
      return null;
    },
  },
];

export const masterCalculationRules = [
  {
    triggerFields: ["start_date", "end_date", "wo_id"],
    calculate: async (formData, changedField) => {
      let updatedValues = { ...formData };
      let dropdownOptions = {};
      let listData = {
        assets: [],
      };

      // ✅ Set reset flag when dates change
      if (changedField === "start_date" || changedField === "end_date") {
        updatedValues.__resetTransactions = true;
        console.log('🔄 [Calc Rule] Date changed, setting reset flag');
      }

      if (changedField === "wo_id") {
        updatedValues.__resetTransactions = true;
      }

      const wo_id = formData.wo_id?.id || formData.wo_id;
      const start_date = formData.start_date;
      const end_date = formData.end_date;

      if (!wo_id) {
        updatedValues.wo_date = null;
        updatedValues.amendment_no = null;
        updatedValues.amendment_date = null;
        listData.assets = [];
        return [updatedValues, {}, listData];
      }

      try {
        // Fetch WO details
        const wo_response = await fetch(
          `${common_api}/work-order/api/work-orders/${wo_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (!wo_response.ok) {
          throw new Error("Failed to fetch work order details.");
        }
        const work_order = await wo_response.json();

        updatedValues.wo_date = work_order.wo_date
          ? new Date(work_order.wo_date).toISOString().split("T")[0]
          : null;
        updatedValues.amendment_no = work_order.amendment_no;
        updatedValues.amendment_date = work_order.amendment_date
          ? new Date(work_order.amendment_date).toISOString().split("T")[0]
          : null;

updatedValues.cust_id = work_order.cust_id;
updatedValues.site_id = work_order.project_id;

// ✅ DEFINE obj_tran query (THIS WAS MISSING!)
const obj_tran = {
  selectedFields: [
    "DISTINCT work_order_tran.id",
    "work_order_tran.*",
    "assets.name",
    "assets.serial_number",
    "assets.registration_number",
    "assets.asset_type",
  ],
  joins: [
    {
      type: "INNER JOIN",
      fromTable: "work_order_tran",
      fromColumn: "asset_id",
      toTable: "assets",
      toColumn: "id",
    },
  ],
  orConditions: [
    {
      type: "date_range_column",
      table: "work_order_tran",
      date: start_date,
      startColumn: "start_date",
      endColumn: "end_date",
    },
    {
      type: "date_range_column",
      table: "work_order_tran",
      date: end_date,
      startColumn: "start_date",
      endColumn: "end_date",
    },
    {
      type: "date_range",
      table: "work_order_tran",
      column: "start_date",
      start: start_date,
      end: end_date,
    },
    {
      type: "date_range",
      table: "work_order_tran",
      column: "end_date",
      start: start_date,
      end: end_date,
    },
  ],
};

const queryStringTran = objectToQueryString(obj_tran);
const res = await fetch(
  `${common_api}/work-order/api/work-order-tran/${wo_id}?${queryStringTran}`,
  {
    headers: { Authorization: `Bearer ${token}` },
  }
);
if (!res.ok) {
  throw new Error("Failed to fetch work order transactions.");
}
const transactions_from_api = await res.json();

console.log('📦 [Calc Rule] Fetched WO transactions:', transactions_from_api.length);

// 🔥 Enrich with asset data if missing
const enrichedTransactions = await Promise.all(
  transactions_from_api.map(async (tran) => {
    // Check if asset data is missing
    if (!tran.name || !tran.asset_type) {
      console.log(`📦 [Calc Rule] Asset data missing for asset_id: ${tran.asset_id}, fetching...`);
      try {
        const assetRes = await fetch(
          `${asset_api}/api/assets/${tran.asset_id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        if (assetRes.ok) {
          const assetData = await assetRes.json();
          console.log(`✅ [Calc Rule] Fetched asset data for ${tran.asset_id}:`, assetData.name);
          
          // Add missing asset fields
          tran.name = assetData.name;
          tran.asset_type = assetData.asset_type;
          tran.serial_number = assetData.serial_number || tran.serial_number;
          tran.registration_number = assetData.registration_number || tran.registration_number;
        } else {
          console.warn(`⚠️ [Calc Rule] Failed to fetch asset ${tran.asset_id}`);
        }
      } catch (error) {
        console.error(`❌ [Calc Rule] Error fetching asset ${tran.asset_id}:`, error);
      }
    } else {
      console.log(`✅ [Calc Rule] Asset data already present for ${tran.asset_id}:`, tran.name);
    }
    return tran;
  })
);

listData.assets = enrichedTransactions;

console.log('🎉 [Calc Rule] Returning enriched assets:', enrichedTransactions.length);
      } catch (error) {
        console.error("Error in WO ID calculation rule:", error);
        listData.assets = [];
      }
      return [updatedValues, dropdownOptions, listData];
    },
  },
  {
    triggerFields: ["inv_date", "cr_period"],
    calculate: async (formData) => {
      const updatedValues = {};
      const invDate = formData.inv_date;
      const crPeriod = parseFloat(formData.cr_period) || 0;

      if (invDate) {
        const invDateObj = new Date(invDate);
        const dueDateObj = new Date(invDateObj);
        dueDateObj.setDate(invDateObj.getDate() + crPeriod);
        updatedValues.due_date = dueDateObj.toISOString().split("T")[0];
      } else {
        updatedValues.due_date = null;
      }

      return [updatedValues, {}, {}];
    },
  },
];

export const masterCalculatedFieldsFn = async (masterData, tranData) => {
  const updatedValues = tranData.reduce(
    (a, tran) => ({
      taxable_amt: a.taxable_amt + parseFloat(tran.taxable_amount || 0),
      tot_cgst: a.tot_cgst + parseFloat(tran.cgst_amount || 0),
      tot_sgst: a.tot_sgst + parseFloat(tran.sgst_amount || 0),
      tot_igst: a.tot_igst + parseFloat(tran.igst_amount || 0),
      amount: a.amount + parseFloat(tran.amount || 0),
    }),
    {
      taxable_amt: 0,
      tot_cgst: 0,
      tot_sgst: 0,
      tot_igst: 0,
      amount: 0,
    }
  );
  return [{ ...masterData, ...updatedValues }, tranData];
};

export const masterFormConfig = {
  masterFormHeading,
  listApi: masterListApi,
  submitApi: masterSubmitApi,
  formFields: masterFormFields,
  validationRules: masterValidationRules,
  calculationRules: masterCalculationRules,
};

// --- Transaction Form Configuration (invoice_tran) ---
export const transactionSubmitApi = `${common_api}/invoice/api/invoice-tran`;

// ✅ FIX: Add separate list API endpoint for fetching transactions
export const transactionListApi = `${common_api}/invoice/api/invoice-tran`;

export const parentIdColumnName = "inv_id";

export const transactionFormFields = [
  {
    fieldName: "inv_sr_no",
    displayName: "SR No.",
    tag: "span",
    readOnly: true,
    properties: {
      minWidth: 20,
    },
  },
  {
    fieldName: "invoice_for",
    displayName: "Invoice For",
    required: true,
    tag: "select",
    properties: {
      minWidth: 155,
    },
    getOptions: async (transactionData, masterFormData) => {
      try {
        // ✅ FIX: Fetch ALL invoice_for options from API (no filtering)
        const res = await fetch(
          `${common_api}/api/get-column/common_master/invoice_for`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        
        if (!res.ok) {
          throw new Error("Failed to fetch invoice_for options.");
        }
        
        const allInvoiceForOptions = await res.json();
        
        console.log('📋 [Invoice For] Fetched all options from API:', allInvoiceForOptions);
        
        // ✅ Return all options without filtering
        // The API returns array of { id, value } objects
        return allInvoiceForOptions.map(option => ({
          id: option.value,      // Use value as id for consistency
          value: option.value,   // Display value
          label: option.value    // Add label for compatibility
        }));
        
      } catch (error) {
        console.error("Error fetching invoice_for options:", error);
        return [];
      }
    },
  },
  {
    fieldName: "asset_id",
    displayName: "Asset",
    required: true,
    tag: "combobox",
    readOnly: true,
    identifier: true,
    properties: { minWidth: 200 },
    load: async (tran) => {
      try {
        const assetId = tran.asset_id?.id || tran.asset_id;
        
        console.log('🔍 [Asset Load] Loading asset ID:', assetId);
        
        const assetRes = await fetch(
          `${asset_api}/api/assets/${assetId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        if (assetRes.ok) {
          const assetData = await assetRes.json();
          
          console.log('✅ [Asset Load] Fetched asset data:', {
            id: assetData.id,
            name: assetData.name,
            type: assetData.asset_type,
            registration: assetData.registration_number,
            serial: assetData.serial_number
          });
          
          // Create comprehensive label with name, type, and identifiers
          const labelParts = [assetData.name];
          
          if (assetData.registration_number) {
            labelParts.push(assetData.registration_number);
          }
          
          if (assetData.serial_number) {
            labelParts.push(assetData.serial_number);
          }
          
          if (assetData.asset_type) {
            labelParts.push(`(${assetData.asset_type})`);
          }
          
          const assetLabel = labelParts.join(' | ');
          
          console.log('✅ [Asset Load] Created label:', assetLabel);
          
          tran.asset_id = {
            id: assetData.id,
            label: assetLabel,
            value: assetData.id,
            name: assetData.name,
            asset_type: assetData.asset_type,
            original: {
              ...assetData,
              daily_rate: parseFloat(assetData.daily_rate || 0),
              monthly_rate: parseFloat(assetData.monthly_rate || 0),
              rate_per_hr: parseFloat(assetData.rate_per_hr || 0),
              mob: parseFloat(assetData.mob || 0),
              demob: parseFloat(assetData.demob || 0),
            },
          };
          
          console.log('✅ [Asset Load] Final asset_id object:', tran.asset_id);
        }
      } catch (e) {
        console.error("❌ [Asset Load] Error:", e);
      }
      return tran;
    },
    getOptionLabel: (option) => {
      if (!option || typeof option !== 'object') return String(option || '');
      
      if (option.label) return option.label;
      
      const parts = [option.name];
      if (option.registration_number) parts.push(option.registration_number);
      if (option.serial_number) parts.push(option.serial_number);
      if (option.asset_type) parts.push(`(${option.asset_type})`);
      
      return parts.filter(Boolean).join(' | ') || `Asset ${option.id}`;
    },
    getOptionValue: (option) => option?.id || option?.value || option,
    renderOption: (option) => {
      if (!option) return null;
      
      const name = option.name || 'Unknown Asset';
      const type = option.asset_type || option.original?.asset_type;
      const registration = option.registration_number || option.original?.registration_number;
      const serial = option.serial_number || option.original?.serial_number;
      
      return (
        <div style={{
          padding: '10px 14px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          flexDirection: 'column',
          gap: '4px'
        }}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            fontWeight: 600 
          }}>
            <span>{name}</span>
            {type && (
              <span style={{ 
                fontSize: '0.85em', 
                color: '#6c757d',
                fontWeight: 400 
              }}>
                ({type})
              </span>
            )}
          </div>
          {(registration || serial) && (
            <div style={{ 
              fontSize: '0.85em', 
              color: '#6c757d',
              display: 'flex',
              gap: '12px'
            }}>
              {registration && <span>Reg: {registration}</span>}
              {serial && <span>Serial: {serial}</span>}
            </div>
          )}
        </div>
      );
    }
  },
  {
    fieldName: "hsn_code",
    displayName: "HSN Code",
    tag: "input",
    inputType: "text",
    readOnly: true,
    properties: {
      minWidth: 120,
    },
    defaultValue: "",
  },
  {
    fieldName: "start_date",
    displayName: "From Date",
    sequence: 3,
    required: true,
    tag: "input",
    inputType: "date",
    properties: {
      minWidth: 200,
    },
    defaultValue: (master) => master?.start_date,
    skipOriginal: true,
    formatDisplay: formatDateToDDMMYYYY,
  },
  {
    fieldName: "end_date",
    displayName: "To Date",
    sequence: 3,
    required: true,
    tag: "input",
    inputType: "date",
    properties: {
      minWidth: 200,
    },
    defaultValue: (master) => master?.end_date,
    skipOriginal: true,
    formatDisplay: formatDateToDDMMYYYY,
  },
  {
  fieldName: "quantity",
  displayName: "Quantity",
  sequence: 4,
  required: true,
  tag: "input",
  inputType: "number",
  properties: {
    minWidth: 100,
  },
  defaultValue: 0,
  step: 0.01, // ✅ NEW: Allow decimal values
  // No min attribute - allows negative values
},
  {
    fieldName: "unit",
    displayName: "Unit",
    sequence: 4,
    tag: "select",
    defaultValue: null,
    required: true,
    data: {
      dependsOnField: "invoice_for",
    },
    send_value: true,
    properties: {
      minWidth: 140,
    },
    getOptions: async () => {
      const res = await fetch(
        `${common_api}/api/get-column/common_master/unit`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) {
        console.error("Failed to fetch unit of measure options.");
        return [];
      }
      const all_units = await res.json();
      return all_units;
    },
  },
  {
    fieldName: "rate",
    displayName: "Rate",
    sequence: 5,
    required: true,
    tag: "input",
    inputType: "number",
    defaultValue: 0,
    properties: {
      minWidth: 175,
    },
    hasHelpButton: true,
  },
  {
    fieldName: "taxable_amount",
    displayName: "Taxable Amount",
    sequence: 6,
    readOnly: true,
    tag: "input",
    inputType: "number",
    properties: {
      minWidth: 150,
    },
    defaultValue: 0,
  },
  {
    fieldName: "cgst_percentage",
    displayName: "CGST (%)",
    sequence: 7,
    tag: "input",
    inputType: "number",
    readOnly: true,
    properties: {
      minWidth: 100,
    },
    defaultValue: 0,
  },
  {
    fieldName: "cgst_amount",
    displayName: "CGST Amt",
    sequence: 8,
    tag: "input",
    inputType: "number",
    readOnly: true,
    properties: {
      minWidth: 150,
    },
    defaultValue: 0,
  },
  {
    fieldName: "sgst_percentage",
    displayName: "SGST (%)",
    sequence: 9,
    tag: "input",
    inputType: "number",
    readOnly: true,
    properties: {
      minWidth: 100,
    },
    defaultValue: 0,
  },
  {
    fieldName: "sgst_amount",
    displayName: "SGST Amt",
    sequence: 10,
    tag: "input",
    inputType: "number",
    readOnly: true,
    properties: {
      minWidth: 150,
    },
    defaultValue: 0,
  },
  {
    fieldName: "igst_percentage",
    displayName: "IGST (%)",
    sequence: 11,
    tag: "input",
    inputType: "number",
    readOnly: true,
    properties: {
      minWidth: 100,
    },
    defaultValue: 0,
  },
  {
    fieldName: "igst_amount",
    displayName: "IGST Amt",
    sequence: 12,
    tag: "input",
    inputType: "number",
    readOnly: true,
    properties: {
      minWidth: 150,
    },
    defaultValue: 0,
  },
  {
    fieldName: "amount",
    displayName: "Total Amount",
    sequence: 13,
    readOnly: true,
    tag: "input",
    inputType: "number",
    properties: {
      minWidth: 150,
    },
    defaultValue: 0,
  },
  {
    fieldName: "remarks",
    displayName: "Remarks",
    sequence: 14,
    tag: "textarea",
    defaultValue: "",
    rows: 1,
    properties: {
      minWidth: 200,
    },
  },
];

export const transactionValidationRules = [
  {
    validator: (
      transaction,
      allErrors,
      allTransactions,
      currentIndex,
      masterRecordDates
    ) => {
      const errors = { ...allErrors };
      if (!transaction.asset_id) {
        errors.asset_id = "Asset is required.";
      }
      if (!transaction.start_date) {
        errors.start_date = "From Date is required.";
      }
      if (!transaction.end_date) {
        errors.end_date = "To Date is required.";
      }
      if (transaction.start_date && transaction.end_date) {
        const tranStartDate = new Date(transaction.start_date);
        const tranEndDate = new Date(transaction.end_date);
        if (tranStartDate > tranEndDate) {
          errors.end_date = "To Date cannot be before From Date.";
        }

        if (masterRecordDates.start_date && masterRecordDates.end_date) {
          const masterStartDate = new Date(masterRecordDates.start_date);
          const masterEndDate = new Date(masterRecordDates.end_date);

          if (tranStartDate < masterStartDate) {
            errors.start_date = "From Date cannot be before Master From Date.";
          }
          if (tranEndDate > masterEndDate) {
            errors.end_date = "To Date cannot be after Master To Date.";
          }
        }
      }
      if (
  transaction.quantity === null ||
  transaction.quantity === undefined ||
  transaction.quantity === "" ||
  isNaN(parseFloat(transaction.quantity))
) {
  errors.quantity = "Quantity is required and must be a valid number.";
}
      if (
        transaction.rate === null ||
        transaction.rate === undefined ||
        parseFloat(transaction.rate) < 0 ||
        isNaN(parseFloat(transaction.rate))
      ) {
        errors.rate = "Rate must be a non-negative number.";
      }

      if (Object.keys(errors).length > 0) {
        return errors;
      }
      return null;
    },
  },
  {
    validator: (transaction, currentErrors) => {
      const errors = { ...currentErrors };
      if (transaction.unit === "ls") {
        return Object.keys(errors).length > 0 ? errors : null;
      }
      const start_date = new Date(transaction.start_date);
      const end_date = new Date(transaction.end_date);
      const noOfDays = noOfDaysBetweenTwoDates(start_date, end_date);
      if (transaction.unit === "monthly_rate" && noOfDays > 12) {
        errors.quantity = "Quantity cannot be greater than 12 for Monthly Rate";
      }

      return Object.keys(errors).length > 0 ? errors : null;
    },
  },
];

// In module.js - Replace your transactionCalculationRules with this:

export const transactionCalculationRules = [
  {
    triggerFields: ["invoice_for", "asset_id"],
    calculate: async (transaction, changedField, masterFormData) => {
      const updatedValues = {};
      
      // Fetch HSN code if invoice_for is available
      if (transaction.invoice_for) {
        try {
          const hsnResponse = await fetch(
            `${common_api}/api/get-column/common_master/hsn_code?invoice_for=${transaction.invoice_for}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          
          if (hsnResponse.ok) {
            const hsnData = await hsnResponse.json();
            if (hsnData && hsnData.length > 0) {
              updatedValues.hsn_code = hsnData[0].value;
            }
          }
        } catch (error) {
          console.error('Error fetching HSN code:', error);
        }
      }

      // Fetch tax info only if both invoice_for AND asset_id are available
      // AND tax percentages are not already set
      if (
        transaction.invoice_for &&
        transaction.asset_id &&
        !transaction.cgst_percentage && 
        !transaction.sgst_percentage && 
        !transaction.igst_percentage
      ) {
        try {
          const wo_id = masterFormData.wo_id?.id || masterFormData.wo_id;
          if (!wo_id) {
            return updatedValues;
          }

          const asset_id = typeof transaction.asset_id === 'object' 
            ? transaction.asset_id.id 
            : transaction.asset_id;

          const taxResponse = await fetch(
            `${common_api}/work-order/api/work-order-tran?wo_id=${wo_id}&asset_id=${asset_id}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          if (taxResponse.ok) {
            const taxData = await taxResponse.json();
            if (taxData && taxData.length > 0) {
              const taxInfo = taxData[0];
              const taxPercentage = parseFloat(taxInfo.tax_percentage || 0);
              const taxType = taxInfo.tax_type || '';

              if (taxType === 'IGST') {
                updatedValues.igst_percentage = parseFloat(taxPercentage.toFixed(2));
                updatedValues.cgst_percentage = parseFloat((0).toFixed(2));
                updatedValues.sgst_percentage = parseFloat((0).toFixed(2));
              } else if (taxType === 'CGST-SGST') {
                updatedValues.cgst_percentage = parseFloat((taxPercentage / 2).toFixed(2));
                updatedValues.sgst_percentage = parseFloat((taxPercentage / 2).toFixed(2));
                updatedValues.igst_percentage = parseFloat((0).toFixed(2));
              } else {
                updatedValues.cgst_percentage = parseFloat((0).toFixed(2));
                updatedValues.sgst_percentage = parseFloat((0).toFixed(2));
                updatedValues.igst_percentage = parseFloat((0).toFixed(2));
              }
            }
          }
        } catch (error) {
          console.error('Error fetching tax details:', error);
        }
      }

      return updatedValues;
    },
  },
  {
    triggerFields: [
      "quantity",
      "rate",
      "unit",
      "cgst_percentage",
      "sgst_percentage",
      "igst_percentage",
    ],
    calculate: async (transaction, changedField, masterFormData) => {
      const currentTransaction = { ...transaction };
      const updatedValues = {};

      const quantity = parseFloat(currentTransaction.quantity || 0);
      const rate = parseFloat(currentTransaction.rate || 0);
      const taxableAmount = parseFloat((quantity * rate).toFixed(2));

      updatedValues.rate = parseFloat(rate.toFixed(2));
      updatedValues.taxable_amount = parseFloat(taxableAmount.toFixed(2));

      const cgstPercentage = parseFloat(currentTransaction.cgst_percentage || 0);
      const sgstPercentage = parseFloat(currentTransaction.sgst_percentage || 0);
      const igstPercentage = parseFloat(currentTransaction.igst_percentage || 0);

      updatedValues.cgst_amount = parseFloat(((taxableAmount * cgstPercentage) / 100).toFixed(2));
      updatedValues.sgst_amount = parseFloat(((taxableAmount * sgstPercentage) / 100).toFixed(2));
      updatedValues.igst_amount = parseFloat(((taxableAmount * igstPercentage) / 100).toFixed(2));

      const finalCgstAmount = parseFloat(updatedValues.cgst_amount || 0);
      const finalSgstAmount = parseFloat(updatedValues.sgst_amount || 0);
      const finalIgstAmount = parseFloat(updatedValues.igst_amount || 0);
      const totalAmount = taxableAmount + finalCgstAmount + finalSgstAmount + finalIgstAmount;

      updatedValues.amount = parseFloat(totalAmount.toFixed(2));

      return updatedValues;
    },
  },
];

export const transactionFormConfig = {
  transactionSubmitApi,
  submitApi: transactionSubmitApi,
  listApi: transactionListApi, // ✅ FIX: Now properly defined
  formFields: transactionFormFields,
  validationRules: transactionValidationRules,
  calculationRules: transactionCalculationRules,
};

export const transactionSummaryFields = [
  "taxable_amount",
  "cgst_amount",
  "cgst_percentage",
  "sgst_amount",
  "sgst_percentage",
  "igst_amount",
  "igst_percentage",
  "amount",
];
export const calculateTransactionTotals = (transactions, summaryFields) => {
  return transactions.reduce(
    (acc, tran) => {
      summaryFields.forEach((field) => {
        acc[field] += parseFloat(tran[field] || 0);
      });
      return acc;
    },
    summaryFields.reduce((acc, field) => ({ ...acc, [field]: 0 }), {})
  );
};

export const transactionSectionLoads = [
  {
    name: "companyState",
    loadFunction: getCompanyState,
  },
];

export const getSummaryColSpan = (transactionFormConfig, summaryFields) => {
  const firstSummaryFieldIndex = transactionFormConfig.formFields.findIndex(
    (f) => f.fieldName === summaryFields[0]
  );
  return firstSummaryFieldIndex > -1 ? firstSummaryFieldIndex : 0;
};